import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ProductBrand } from 'types/schema';
import agradeTagImg from './images/agrade_tag.png?as=webp';
import agradeTagImgEn from './images/agrade_tag_en.png?as=webp';
import bannerBestDealsImg from './images/banner-best-deals.png?as=webp';
import bannerBestDealsEnImg from './images/banner-best-deals-en.png?as=webp';
import bannerBestPricesImg from './images/banner-best-prices.png?as=webp';
import bannerBestPricesEnImg from './images/banner-best-prices-en.png?as=webp';
import bannerNewProductsImg from './images/banner-new-products.png?as=webp';
import bannerNewProductsEnImg from './images/banner-new-products-en.png?as=webp';
import bestCaseValueImg from './images/best-case-value.png?as=webp';
import fromFarmImg from './images/from_farm.png?as=webp';
import kamereoEssentialImg from './images/kamereo-essential.png?as=webp';
import kamereoFreshImg from './images/kamereo-fresh.png?as=webp';
import superSavingImg from './images/super_saving.png?as=webp';

const FEATURED_CATEGORIES = [
  {
    nameLocal: 'Hàng Loại 1',
    nameEn: 'A-Grade Products',
    href: '/AGRADE_TAG',
    color: '#F9F4FF',
    image: agradeTagImg,
    imageEn: agradeTagImgEn,
  },
  {
    nameLocal: 'Siêu Tiết Kiệm',
    nameEn: 'Super Saving',
    href: '/SUPER_SAVING_TAG',
    color: '#FFF0DA',
    image: superSavingImg,
    imageEn: superSavingImg,
    top: '-5',
  },
  {
    nameLocal: 'Tươi Từ Nông Trại',
    nameEn: 'Farm to Business',
    href: '/tu-nong-trai-den-doanh-nghiep',
    color: '#F0FFD0',
    image: fromFarmImg,
    imageEn: fromFarmImg,
  },
  {
    nameLocal: 'Hàng Thùng Giá Tốt',
    nameEn: 'Bulk Buying Best Prices',
    href: '/HANG_THUNG_GIA_TOT',
    color: '#FFF2FA',
    image: bestCaseValueImg,
    imageEn: bestCaseValueImg,
  },
  {
    nameLocal: 'KAMEREO Ngon',
    nameEn: 'Kamereo Fresh',
    href: '/kamereo-ngon',
    color: '#E9F5FF',
    image: kamereoFreshImg,
    imageEn: kamereoFreshImg,
  },
  {
    nameLocal: 'KAMEREO Tiện Dụng',
    nameEn: 'Kamereo Essential',
    href: '/kamereo-tien-dung',
    color: '#EBFFEA',
    image: kamereoEssentialImg,
    imageEn: kamereoEssentialImg,
  },
];

const FEATURED_PROMOTIONS = [
  {
    titleLocal: 'Siêu Ưu Đãi Độc Quyền',
    titleEn: 'Exclusive Best Deals',
    href: '/BEST_DEALS',
    hrefMB: '/BEST_DEALS_HN',
    image: bannerBestDealsImg,
    imageEn: bannerBestDealsEnImg,
  },
  {
    titleLocal: 'Sản Phẩm Mới - Ưu Đãi Hấp Dẫn',
    titleEn: 'New Products - Great Offers',
    href: '/NEW_PRODUCTS',
    hrefMB: '/NEW_PRODUCTS',
    image: bannerNewProductsImg,
    imageEn: bannerNewProductsEnImg,
  },
  {
    titleLocal: 'Giá Tốt - Tuần Này',
    titleEn: 'Best Prices - This Week',
    href: '/BEST_PRICES',
    hrefMB: '/BEST_PRICES_HN',
    image: bannerBestPricesImg,
    imageEn: bannerBestPricesEnImg,
  },
];

/* ─── Styled components ──────────────────────────────────────────────────────── */
const TopChoiceCol = styled.div`
  flex: 1;
  background: #ffffff;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 516px;
  overflow-y: auto;
  min-width: 0;
`;

const PromoCol = styled.div`
  max-width: 328px;
  flex-shrink: 0;
  background: #ffffff;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SectionTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 22px;
  margin: 0;
`;

const TileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
`;

const Tile = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 140px;
  height: 130px;
  text-decoration: none;
  &:hover .tile-avatar {
    opacity: 0.85;
  }
`;

const TileFeatureCategory = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 140px;
  text-decoration: none;
  &:hover .tile-avatar {
    opacity: 0.85;
  }
`;

const TileAvatar = styled.div<{ color?: string }>`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: ${({ color }) => color || '#fff'};
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: opacity 0.15s ease;
`;

const TileLabel = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: #111827;
  text-align: center;
  line-clamp: 2;
  max-width: 70%;
`;

const Divider = styled.div`
  height: 1px;
  background: #f2f3f5;
  width: 100%;
  flex-shrink: 0;
`;

const PromoCard = styled(Link)`
  display: block;
  width: 280px;
  height: 140px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
`;

/* ─── Component ───────────────────────────────────────────────────────────────
 * Renders the inner content of the mega menu's "Top choice" right panel —
 * expects to be mounted as the direct children of the shared `RightContent`
 * flex row in CategoryMegaMenu.
 */
interface TopChoicePanelProps {
  lang: string;
  brands: ProductBrand[];
  region?: string | null;
  onItemClick: () => void;
}

const TopChoicePanel: FC<TopChoicePanelProps> = ({ lang, brands, region, onItemClick }) => (
  <>
    <TopChoiceCol>
      {region !== 'HN' && (
        <>
          <Section>
            <SectionTitle>{lang === 'vi' ? 'Độc quyền từ hãng' : 'Exclusives from Brands'}</SectionTitle>

            <TileGrid>
              {brands.map((brand) => (
                <Tile key={brand.id} to={`/thuong-hieu/${brand.slug}-b${brand.id}`} onClick={onItemClick}>
                  <TileAvatar className="tile-avatar">
                    {brand.imageUrl && (
                      <img
                        src={brand.imageUrl}
                        alt={brand.name ?? ''}
                        style={{ width: '80px', height: '80px', objectFit: 'contain', display: 'block' }}
                      />
                    )}
                  </TileAvatar>

                  <TileLabel>{brand.name}</TileLabel>
                </Tile>
              ))}
            </TileGrid>
          </Section>

          <Divider />
        </>
      )}

      <Section>
        <SectionTitle>{lang === 'vi' ? 'Danh mục nổi bật' : 'Featured Categories'}</SectionTitle>
        <TileGrid>
          {FEATURED_CATEGORIES.map((item) => {
            const name = lang === 'vi' ? item.nameLocal : item.nameEn;
            const image = lang === 'vi' ? item.image : item.imageEn;
            return (
              <TileFeatureCategory key={item.href} to={item.href} onClick={onItemClick}>
                <TileAvatar color={item.color} className="tile-avatar">
                  <img
                    src={image}
                    alt={name}
                    style={{
                      width: '90%',
                      height: '90%',
                      objectFit: 'contain',
                      display: 'block',
                      top: item.top || '0',
                      position: item.top ? 'relative' : 'static',
                    }}
                  />
                </TileAvatar>
                <TileLabel>{name}</TileLabel>
              </TileFeatureCategory>
            );
          })}
        </TileGrid>
      </Section>
    </TopChoiceCol>

    <PromoCol>
      <SectionTitle>{lang === 'vi' ? 'Khuyến mãi nổi bật' : 'Featured Deals'}</SectionTitle>
      {FEATURED_PROMOTIONS.map((promo) => {
        const title = lang === 'vi' ? promo.titleLocal : promo.titleEn;
        const image = lang === 'vi' ? promo.image : promo.imageEn;
        return (
          <PromoCard key={promo.href} to={region === 'HN' ? promo.hrefMB : promo.href} onClick={onItemClick}>
            <img
              src={image}
              alt={title}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </PromoCard>
        );
      })}
    </PromoCol>
  </>
);

export default TopChoicePanel;
